module.exports = {
  realm: 'NB',
  market: 'nl-BE',
  domain: 'weightwatchers.be',
  countryId: '9000',
  vsPath: 'be/nl',
  spiceLocale: 'nb',
  vsUrl: 'https://www{env}weightwatchers.com/be/nl',
  spiceUrl: 'https://www{env}weightwatchers.com/assets/cmx/nb/messages/',
  cmxSiteUrl: 'https://cmx{env}weightwatchers.be/',
  currency: '€',
  decimalSeparator: ',',
  thousandSeparator: '.',
  currencyFormat: '€ %number',
  dateFormat: 'dd/MM/yyyy',
  loginApiUrl: 'https://auth{env}weightwatchers.be/login-apis/',
  loginWebUrl: 'https://auth{env}weightwatchers.be/v2/login/',
  countryCode: 'BE',
  commUlr: 'https://commerce{env}weightwatchers.com/be/nl/api/',
  timezone1: 'Europe/Brussels',
  timezone2: '+01:00',
};
